import React, { useEffect, useState } from 'react';
import Layout from '../../Layout/Layout';
import { Col, Row, Form } from 'react-bootstrap';
import noimage from "../../assets/img/noimage.png";
import { VideoTest, addnewpromotion, getnewpromotion } from '../../actions/users';
import { ImgEmpty, isEmpty } from '../../actions/commonFunction';
import AudioImg from '../../assets/img/AudioImg.jpg'
import config from "../../lib/config"
import { toast } from 'react-toastify';

const PromotionList = () => {


    const [imgfilename, setimgfilename] = useState('');
  const [fileSizes, setfilesize] = useState(0)
  const [TokenFile, setTokenFile] = useState("");
  const [TokenFilePreUrl, setTokenFilePreUrl] = useState("");
  const [TokenFilePreReader, setTokenFilePreReader] = useState("");
  const [imgpath, setimgpath] = useState("");
  const [answer, setanswer] = useState("");
  const [question, setquestion] = useState("");
  const [validateError, setValidateError] = useState({});
  const [profile, setProfile] = useState({});


  useEffect(() => {
    getInit()
  }, [])

  // console.log('TokenFilePreReaderTokenFilePreReader',TokenFilePreReader)

  const getInit = async () => {
    let data = await getnewpromotion()
    let promotion = data?.data?.data;
    
    let file = promotion?.promotion[0]?.image
    let path = `${config.Back_Url}/newpromotion/${file}`
    
    setimgfilename(file)
    setimgpath(path)

    setProfile({
      creator: promotion?.promotion[0]?.creator,
      TokenName: promotion?.promotion[0]?.TokenName,
      Profile: promotion?.promotion[0]?.Profile,
      id: promotion?.promotion[0]?._id
    })

    //    CMS
    let test = data?.data?.data;
    
    if (test && test.cms) {
      if (test.cms.question) {
        setquestion(test.cms.question)
      }
      if (test.cms.answer) {
        setanswer(test.cms.answer)
      }
    }

  }

  const selectFileChange = async (e) => {
    setValidateError({})
    if (e.target.name == 'file') {
      setimgpath("")
      setimgfilename("")
      var validExtensions = ["png", 'gif', 'webp', 'mp4', 'PNG', 'jpg', 'JPEG', 'jpeg', 'JPG', 'mp3', 'aac', 'AAC', 'flac', 'FLAC', 'WEBM', 'webm', 'ogv', 'OGV']; //array of valid extensions
      if (e.target && e.target.files) {
        var reader = new FileReader()
        var file = e.target.files[0];
        const { value } = e.target;
        
        if (file.type.includes('video')) {
          let test = await VideoTest(file);
          
          // if (test?.data?.data) {
          //   if (test?.data?.data?.height == 1080 && test?.data?.data?.width == 1920) {

          //   }
          //   else {
          //     toast.error('Uploade Video must be 1080*1920 format')
          //     return false;
          //   }
          // }
          // else {
          //   toast.error('Try-Again')
          //   return false;
          // }
        }
        setimgfilename(file.name)

        var fileName = file.name;
        var fileNameExt = fileName.substr(fileName.lastIndexOf('.') + 1);
        if (validExtensions.findIndex((check)=>check==fileNameExt) === -1) {
          toast.error("Only these file types are accepted : " + validExtensions.join(', '));
          return false;
        }
        const fileSize = file.size;
        if (50000000 < fileSize) {
          toast.error("File size exceeds 50 MB");
          return false;
        }
        else {
          
          setfilesize(fileSize)
          
          setTokenFile(file);
          var url = reader.readAsDataURL(file);
          setTokenFilePreUrl(value);
          reader.onloadend = function (e) {
            if (reader.result) {

              
              setTokenFilePreReader(reader.result);
            }
          }.bind(this);
        }
      }
    }
    else if (e.target.name == 'profile') {
      var file = e.target.files[0];
      var fileName = file.name;
      var fileNameExt = fileName.substr(fileName.lastIndexOf('.') + 1);
      var validExtensions = ["png", 'webp', 'PNG', 'jpg', 'JPEG', 'jpeg', 'JPG']; //array of valid extensions
      if (validExtensions.findIndex((check)=>check==fileNameExt) === -1) {
        toast.error("Only these file types are accepted : " + validExtensions);
        return false;
      }
      setProfile({ ...profile, ...{ Profile: file } });
    }
  }

  const Oncancel = async (from) => {
    if (from == 'profile') {
      setProfile({ ...profile, ...{ Profile: undefined } })
      toast.success("Cancelled successfully")
    }
    else {
      setimgfilename('')
      setfilesize(0)
      setTokenFile('')
      setTokenFilePreReader('')
      setTokenFilePreUrl('')
      toast.success("Cancelled successfully")
    }

  }

  const Validation = () => {
    const { creator, TokenName, Profile } = profile;
    
    let error = {};
    if (isEmpty(creator)) {
      error.creator = "Enter Creator Name";
    }
    if (isEmpty(TokenName)) {
      error.TokenName = "Enter Token Name";
    }
    if (typeof (Profile) == 'undefined') {
      error.Profile = "Upload Profile Image";
    }
    if (isEmpty(TokenFilePreUrl) && isEmpty(imgfilename)) {
      error.image = "Upload File";
    }
    return error;
  }

  const handleFormSubmit = async () => {
    var validate = Validation();
    
    if (isEmpty(validate)) {
      
      // var crtanswer = answer.
      let senddata = {
        image: TokenFile,
        creator: profile?.creator,
        TokenName: profile?.TokenName,
        Profile: profile?.Profile,
        id: profile?.id,
        question,
        answer,
      }
    //   var formData = new FormData();
    //   formData.append('image', TokenFile);
    //   formData.append('creator', profile?.creator);
    //   formData.append('TokenName', profile?.TokenName);
    //   formData.append('Profile', profile?.Profile);
    //   formData.append('id', profile?.id);
    //   formData.append('question', question);
    //   formData.append('answer', answer);

      var addproimg = await addnewpromotion(senddata)
      
      if (addproimg?.status == true) {
        toast.success("successfully updated")
      }
    }
    else {
      setValidateError(validate)
    }
  }

  const OnChange = (e) => {
    setValidateError({})
    setProfile({ ...profile, ...{ [e.target.id]: e.target.value } })
  }

    return (
        <Layout>
            <div className="promotionlist">
                <h1 className="pagehead">Edit CMS</h1>
                <div className="cardbox">
                    <Form>
                        <Row>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Token Name</Form.Label>
                                    <Form.Control type="text" value={profile?.TokenName || ''} id="TokenName" onChange={(e) => OnChange(e)} />
                                    {
                                        validateError.TokenName && <span className="validation_txt">{validateError.TokenName}</span>
                                    }
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Creator</Form.Label>
                                    <Form.Control type="text" value={profile?.creator || ''} id="creator" onChange={(e) => OnChange(e)} />
                                    {
                                        validateError.creator && <span className="validation_txt">{validateError.creator}</span>
                                    }
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group className="d-flex align-items-center gap-4 mb-3">
                                    <div className="flex-grow-1">
                                        <Form.Label>Creator Profile:</Form.Label>
                                        <Form.Control type="file" name="profile" accept="audio/*,video/*,image/*" onChange={selectFileChange} />
                                        <small className="t-grey pl-3 d-block mt-2">JPG, JPEG, PNG, WEBP. Max 50 megabytes</small>
                                    </div>
                                    <button type="button" className="btn sitebtn btn-danger py-2 px-3" onClick={() => Oncancel('profile')}>Cancel</button>
                                    {
                                        validateError.Profile && <span className="validation_txt">{validateError.Profile}</span>
                                    }
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Creator Profile Preview</Form.Label>
                                    <div className="uploadimgbox">
                                        <img
                                            src={
                                                ImgEmpty(profile?.Profile)
                                                ?
                                                noimage
                                                :
                                                (
                                                    typeof (profile?.Profile) == 'string'
                                                    ?
                                                    `${config.Back_Url}/newpromotion/${profile?.Profile}`
                                                    :
                                                    URL.createObjectURL(profile?.Profile)
                                                )
                                            }
                                            alt=""
                                            className="img-fluid previewimg"
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group className="d-flex align-items-center gap-4 mb-3">
                                    <div className="flex-grow-1">
                                        <Form.Label>Upload:</Form.Label>
                                        <Form.Control type="file" name="file" accept="audio/*,video/*,image/*" onChange={selectFileChange} />
                                        <small className="t-grey pl-3 d-block mt-2">JPG, JPEG, PNG, GIF, WEBP, WEPM, OGV, MP3, FLAC, AAC or MP4. Max 50 megabytes</small>
                                    </div>
                                    <button type="button" className="btn sitebtn btn-danger py-2 px-3" onClick={() => Oncancel()}>Cancel</button>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Preview</Form.Label>
                                    <div className="uploadimgbox">
                                        {
                                            TokenFilePreUrl !== "" && ["mp4", "webm", "WEBM", "OGV", "ogv"].includes(TokenFilePreUrl?.split('.')?.pop()) || imgfilename !== "" && ["mp4", "webm", "WEBM", "OGV", "ogv"].includes(imgfilename?.split('.')?.pop()) ?
                                                (<video
                                                    id="imgPreview"
                                                    className="img-fluid previewimg"
                                                    alt="img"
                                                    autoPlay
                                                    controls
                                                    muted
                                                    playsInline
                                                    loop
                                                    src={TokenFilePreReader !== "" ? TokenFilePreReader : imgpath !== ""
                                                        ? imgpath : require('../../assets/img/noimage.png')}
                                                    type="video/mp4"
                                                />)
                                                :
                                                (imgpath === "" && imgfilename === undefined && TokenFilePreReader === "" ?
                                                    (<video
                                                        id="imgPreview"
                                                        className="img-fluid previewimg"
                                                        alt="img"
                                                        autoPlay
                                                        controls
                                                        muted
                                                        playsInline
                                                        loop
                                                        src={imgpath}
                                                        type="video/mp4"
                                                    />)
                                                    :
                                                    null
                                                )
                                        }

                                        {TokenFilePreUrl.split('.').pop() === 'mp3' || imgpath.split('.').pop() === 'mp3' ? (
                                            <>
                                                <img src={AudioImg} className="img-fluid previewimg" />

                                                <audio
                                                    controls
                                                    autoplay
                                                    src={
                                                        TokenFilePreReader !== ""
                                                            ? TokenFilePreReader
                                                            : require('../../assets/img/noimage.png')
                                                    }
                                                >
                                                </audio>

                                            </>
                                        ) : imgpath === "" && imgfilename === undefined && imgpath.split('.').pop() === 'mp3' ? (
                                            <>
                                                <img src={AudioImg} className="img-fluid previewimg" />

                                                <audio
                                                    muted
                                                    id="imgPreview"
                                                    className="img-fluid previewimg"
                                                    alt="img"
                                                    autoPlay
                                                    controls
                                                    playsInline
                                                    loop
                                                    src={
                                                        TokenFilePreReader !== ""
                                                            ? TokenFilePreReader
                                                            : imgpath !== ""
                                                                ? imgpath
                                                                : require('../../assets/img/noimage.png')
                                                    }
                                                    type="audio/mp3"
                                                ></audio>
                                            </>
                                        ) : null}


                                        {["webp", "WEBP", "gif", "jpg", "GIF", "JPG", "JPEG", "jpeg", "png", "PNG"].includes(TokenFilePreUrl?.split('.')?.pop()) ?
                                            (<img src={TokenFilePreReader !== "" ? TokenFilePreReader : require('../../assets/img/noimage.png')} id="imgPreview" alt="Collections" className="img-fluid" />)
                                            :
                                            (imgpath !== "" && imgfilename != undefined && TokenFilePreReader === "" && ["webp", "WEBP", "gif", "jpg", "GIF", "JPG", "JPEG", "jpeg", "png", "PNG"].includes(imgfilename?.split('.')?.pop()) ?
                                                (<img src={imgpath} id="imgPreview" alt="Collections" className="img-fluid previewimg" />)
                                                :
                                                null
                                            )
                                        }

                                        {TokenFilePreReader === "" && (imgfilename === "" || imgfilename === undefined) &&
                                            <img src={require('../../assets/img/noimage.png')} id="imgPreview" alt="Collections" className="img-fluid previewimg" />
                                        }
                                        {/* <img src={noimage} alt="" className="img-fluid previewimg" /> */}
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                        <button type="button" className="btn sitebtn py-2 px-3" onClick={handleFormSubmit}>Update</button>
                    </Form>
                </div>
            </div>
        </Layout>
    )
}

export default PromotionList;